<template>
  <main class="console-page-child control-page-common" id="break-rules-analyze">
    <el-row class="console-title title-border">违章分析</el-row>
    <section>
      <el-row class="btn-query self-range-date">
        <el-radio-group v-model="time" size="small" @change="queryDateChange">
          <el-radio-button label="1">近30天</el-radio-button>
          <el-radio-button label="2">本季度</el-radio-button>
          <el-radio-button label="3">本年度</el-radio-button>
        </el-radio-group>
      </el-row>
      <div class="query-report">
        <div class="query-info">
          <span class="query-vehicle"
            >{{
              time === '1' ? '近30天' : time === '2' ? '本季度' : '本年度'
            }}共查询{{
              analyzeReportData.totalEstimateVehicleCount
            }}辆，其中有效查询{{
              analyzeReportData.totalActualVehicleCount
            }}辆</span
          >
          <p class="query-detail-btn" @click="queryShowDetail">
            <span class="query-vehicle-detail-btn">查看详情</span
            ><span class="el-icon-caret-right"></span>
          </p>
        </div>
        <div class="total-data">
          <div class="total-data-item">
            <p class="item-text">总违章车辆数</p>
            <p class="item-info">
              {{ analyzeReportData.totalVehicleCount }}
            </p>
          </div>
          <div class="total-data-item">
            <p class="item-text">总违章数</p>
            <p class="item-info">{{ analyzeReportData.totalViolationCount }}</p>
          </div>
          <div class="total-data-item">
            <p class="item-text">扣分</p>
            <p class="item-info">{{ analyzeReportData.totalDeductMarks }}</p>
          </div>
          <div class="total-data-item">
            <p class="item-text">罚款总额(元)</p>
            <p class="item-info">
              {{
                analyzeReportData.totalPunishCount
                  ? $utils.toCompareYuan(analyzeReportData.totalPunishCount)
                  : '--'
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="break-rules-ranking-list">
        <div class="brrl-title">
          <span class="brrl-title-text">违章排行榜</span>
          <el-radio-group
            v-model="time1"
            size="mini"
            @change="analyzeRankingList"
          >
            <el-radio-button label="VIOLATION_TIMES">违章次数</el-radio-button>
            <el-radio-button label="DEDUCT_MARKS">扣分</el-radio-button>
            <el-radio-button label="PUNISH_COUNT">罚款</el-radio-button>
          </el-radio-group>
        </div>
        <div class="ranking-list-info">
          <div
            class="rli-detail"
            v-for="(item, index) in rankingListInfo"
            :key="index"
          >
            <p class="rli-detail-text">
              <span class="rli-detail-text-icon" v-if="index < 3">{{
                index + 1
              }}</span>
              {{ item.reason }}
            </p>
            <span
              class="rli-detail-process"
              :style="{ width: item.width }"
              :class="{
                green: time1 === 'DEDUCT_MARKS',
                orange: time1 === 'PUNISH_COUNT',
              }"
            ></span>
            <span class="rli-detail-count">
              {{
                time1 === 'PUNISH_COUNT'
                  ? `${$utils.toCompareYuan(item.aggregate)}元`
                  : time1 === 'DEDUCT_MARKS'
                  ? `${item.aggregate}分`
                  : `${item.aggregate}次`
              }}
            </span>
          </div>
        </div>
      </div>
      <el-vehicle-rank-table :time="rankTableTime"></el-vehicle-rank-table>
    </section>
  </main>
</template>
<script>
import moment from 'moment'
import vehicleRankTable from '../../components/violation-manage/vehicle-ranking-list-table.vue'
export default {
  components: {
    'el-vehicle-rank-table': vehicleRankTable,
  },
  created() {
    this.calculateTime()
    this.analyzeReport()
    this.analyzeRankingList()
  },
  data() {
    return {
      list: [],
      time: '1',
      time1: 'VIOLATION_TIMES',
      startTime: '',
      endTime: '',
      analyzeReportData: {},
      rankingListInfo: [],
      exportParams: {},
    }
  },
  computed: {
    rankTableTime() {
      return {
        startTime: this.startTime,
        endTime: this.endTime,
      }
    },
  },
  methods: {
    /**
     * 近30日 本季度  本年度 切换调用方法
     */
    queryDateChange(val) {
      this.calculateTime()
      this.analyzeReport()
      this.analyzeRankingList()
      // this.analyzeDriverList()
    },
    /**
     * 跳转到历史违章记录页
     */
    vehicleHistoryViolation(params) {
      params = params ? params : {}
      this.$router.push({
        path: '/console/violation/history-violation-query',
        query: {
          ...params,
        },
      })
    },
    /**
     * 跳转到历史违章记录页（url传参）
     */
    calculateTime() {
      if (this.time === '1') {
        this.endTime = moment(new Date()).format('YYYY-MM-DD')
        const end = new Date().getTime() - 3600 * 1000 * 24 * 30
        this.startTime = moment(end).format('YYYY-MM-DD')
      } else if (this.time === '2') {
        const month = new Date().getMonth() + 1
        const year = new Date().getFullYear()
        if (month <= 3) {
          this.startTime = `${year}-01-01`
          this.endTime = `${year}-03-31`
        } else if (month <= 6) {
          this.startTime = `${year}-04-01`
          this.endTime = `${year}-06-30`
        } else if (month <= 9) {
          this.startTime = `${year}-07-01`
          this.endTime = `${year}-09-30`
        } else if (month <= 12) {
          this.startTime = `${year}-10-01`
          this.endTime = `${year}-12-31`
        }
      } else if (this.time === '3') {
        const year = new Date().getFullYear()
        this.startTime = `${year}-01-01`
        this.endTime = `${year}-12-31`
      }
      this.startTime = `${this.startTime} 00:00:00`
      this.endTime = `${this.endTime} 23:59:59`
    },
    queryShowDetail() {
      this.vehicleHistoryViolation({
        startTime: this.startTime,
        endTime: this.endTime,
      })
    },
    /**
     * 违章报告
     */
    analyzeReport() {
      this.$request({
        url: '/proxy/violation/analyze/report',
        method: 'post',
        data: {
          startTime: this.startTime,
          endTime: this.endTime,
        },
      }).then((res) => {
        if (!res) return
        if (res && !res.errorCode && res.data) {
          this.analyzeReportData = res.data
        }
      })
    },
    /**
     * 违章排行榜
     */
    analyzeRankingList() {
      this.$request({
        url: '/proxy/violation/analyze/reason',
        method: 'post',
        data: {
          startTime: this.startTime,
          endTime: this.endTime,
          dimension: this.time1,
        },
      }).then((res) => {
        if (!res) return
        if (res && !res.errorCode && res.data) {
          this.rankingListInfo = res.data.splice(0, 5)
          const maxWidth = 250
          for (const temp of this.rankingListInfo) {
            temp.width =
              (temp.aggregate / this.rankingListInfo[0].aggregate) * 250 + 'px'
          }
        }
      })
    },
  },
}
</script>
<style lang="stylus">
@import '../../assets/css/common-color.styl'
#break-rules-analyze
  section
    .btn-query
      margin 24px 0 16px 0
      .el-radio-button__orig-radio:checked+.el-radio-button__inner
        background rgba(47,134,246,0.10)
        border 1px solid rgba(47,134,246,0.30)
        color primary-color
      .el-radio-button__orig-radio:checked+.el-radio-button__inner
        box-shadow none
      .el-input-group__append, .el-input-group__prepend
        background #fff
    .query-report
      background linear-gradient(rgba(151,194,250,0), rgba(243,248,254,0.2))
      border 1px solid #F0F0F0
      box-shadow 0 4px 12px 1px rgba(226,228,234,0.29)
      border-radius 2px
      .query-info
        padding 13px 25px
        display flex
        align-items center
        justify-content space-between
        margin 8px 8px 0
        background url('../../assets/images/violation-manage/circle.svg') no-repeat 17px center
        background-color rgba(92,187,251,0.1)
        .query-vehicle
          font-family PingFangSC-Regular
          font-size 14px
          color #41485D
          line-height 16px
          margin-left 8px
        .query-detail-btn
          cursor pointer
          .query-vehicle-detail-btn
            font-family PingFangSC-Regular
            font-size 14px
            color #41485D
            line-height 16px
          .el-icon-caret-right
            color #41485D
            font-size 14px
      .total-data
        padding 42px 0 40px
        display flex
        align-items center
        justify-content space-between
        .total-data-item
          border-right 1px solid #DCDFE5
          width 25%
          box-sizing border-box
          text-align center
          &:last-child
            border none
          .item-text
            font-family PingFangSC-Regular
            font-size 14px
            color #666F83
            text-align center
            line-height 14px
            margin-bottom 8px
          .item-info
            font-family DINpro
            font-size 34px
            color #111A34
            line-height 34px
    .break-rules-ranking-list
      margin-top 40px
      .brrl-title
        font-family PingFangSC-Medium
        font-size 16px
        color #41485d
        display flex
        align-items center
        justify-content space-between
        .brrl-title-text
          display inline-block
          height 16px
          line-height 16px
          border-left 2px solid #2f86f6
          padding-left 8px
          font-family PingFangSC-medium
        .el-radio-group
          border 2px solid #F0F0F0
          border-radius 4px
        .el-radio-button, .el-radio-button__inner
          background #f0f0f0
        .el-radio-button__orig-radio:checked+.el-radio-button__inner
          background #FFFFFF
          border none
          border-radius 4px
          font-family PingFangSC-Regular
          font-size 12px
          color #41485D
        .el-radio-button__orig-radio+.el-radio-button__inner
          box-shadow none
          background #F0F0F0
          border none
          color #666f83
          &:hover
            color #41485D
        .el-input-group__append, .el-input-group__prepend
          background #F0F0F0
      .ranking-list-info
        .rli-detail
          margin-top 20px
          display flex
          align-items center
          padding-left 9px
          .rli-detail-text
            font-family PingFangSC-Regular
            font-size 14px
            color #41485D
            text-align right
            line-height 20px
            margin-right 14px
            width 40%
            display inline-block
            .rli-detail-text-icon
              background url(../../assets/images/violation-manage/bg-rl.svg) no-repeat center center
              background-size 100% 100%
              display inline-block
              width 18px
              height 18px
              text-align center
              line-height 18px
              color #fff
              font-size 12px
              font-weight 300
          .rli-detail-process
            display inline-block
            background rgba(47,134,246,0.5)
            margin-right 10px
            height 18px
          .orange
            background rgba(255,125,65,0.5)
          .green
            background rgba(40,170,145,0.5)
          .rli-detail-count
            font-family PingFangSC-Regular
            font-size 12px
            color #41485D
            line-height 12px
            display flex
  .self-contract-wrapper
    max-height 370px
    overflow-y auto
    overflow-x hidden
    .contract-board
      background white
      width 340px
      border none
      margin-bottom 8px
  .self-contract-wrapper::-webkit-scrollbar
    width 8px
    height 8px
  .self-contract-wrapper::-webkit-scrollbar-thumb
    border-radius 2px
    -webkit-box-shadow inset 0 0 5px rgba(0,0,0,0.2)
    background #ebedf1
  .self-contract-wrapper::-webkit-scrollbar-track
    display none
</style>
